import { createSlice, createSelector } from "@reduxjs/toolkit";
import { getItem, saveItem, removeItem } from "./local.store";

// Slice
const slice = createSlice({
  name: "user",
  initialState: {
    token: getItem("token") === undefined ? null : getItem("token"),
    user: getItem("user"),
    refresh_token: getItem("refresh_token") ? null : getItem("refresh_token"),

    loading: false,
    error: null,

    cluster: getItem("cluster") === null ? [] : getItem("cluster"),
    stationID: getItem("stationID"),
    search: getItem("search"),

    metric:
      getItem("metric") === null
        ? {
          label: "temperature",
          value: "air_temp",
          name: "air_temp",
          data: [{ label: "temperature", endpoint: "air_temp" }],
        }
        : getItem("metric"),
  },
  reducers: {
    login: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.token = action.token;
      state.refresh_token = action.refresh_token;
      state.user = action.user;
      saveItem("user", action.user);
      saveItem("token", action.token);
      saveItem("refresh_token", action.refresh_token);
    },
    logout: (state) => {
      state.error = null;
      state.loading = false;
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.refresh_token = null;
      state.token = null;
      state.error = null;
      state.loading = false;
      state.cluster = [];
      state.stationID = null;
      state.metric = null;
      state.search = null;

      removeItem("cluster");
      removeItem("stationID");
      removeItem("search");
      removeItem("token");
      removeItem("user");
      removeItem("refresh_token");
      removeItem("metric");

    },
    error: (state, action) => {
      state.user = null;
      state.token = null;
      state.error = action.error;
      state.loading = false;
      state.typeError = action?.typeError;
      state.refresh_token = null;
      state.cluster = [];
      state.stationID = null;
      state.metric = null;
      state.search = null;
      removeItem("token");
      removeItem("refresh_token");

      removeItem("cluster");
      removeItem("stationID");
      removeItem("search");
      removeItem("user");
      removeItem("metric");
    },
    clearError: (state) => {
      state.error = null;
     
    },
    updateSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.user = action.payload;
      saveItem("user", action.payload);
    },
    checkToken: (state) => {
      state.error = null;
      state.loading = false;
    },
    checkTokenSuccess: (state, action) => {
      state.expires_in = action.expires_in;
    },
    refreshToken: (state) => {
      state.loading = true;
      state.error = null;
    },
    refreshTokenSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.token = action.token;
      state.refresh_token = action.refresh_token;
      state.user.refresh_token = action.refresh_token;
      const user = getItem("user")
      user.refresh_token = action.refresh_token

      saveItem("token", action.token);
      saveItem("refresh_token", action.refresh_token);
      saveItem("user", user);

    },
    //-------------------------------------------
    saveCluster(state, action) {
      state.cluster = action.payload;
      saveItem("cluster", action.payload);
    },
    saveStationID(state, action) {
      state.stationID = action.payload;
      saveItem("stationID", action.payload);
    },
    saveMetric(state, action) {
      state.metric = action.payload;
      saveItem("metric", action.payload);
    },
    saveSearch(state, action) {
      state.search = action.payload;
      saveItem("search", action.payload);
    },

  },
});

export const getTokenSelector = createSelector(
  (state) => state.user,
  (user) => user.token
);

export const {
  login,
  loginSuccess,
  meSuccess,
  logout,
  logoutSuccess,
  error,
  updateSuccess,
  checkToken,
  checkTokenSuccess,
  refreshTokenSuccess,
  refreshToken,

  saveCluster,
  saveStationID,
  saveMetric,
  saveSearch,

  clearError

} = slice.actions;

export default slice.reducer;
